<!-- 视频 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <div class="form-title">视频上传</div>
                        <FormItem label="长宽比例">
                            <Select v-model="newFormData.content.height_id" clearable filterable placeholder="请输入长宽比例">
                                <Option v-for="item in heightList" :value="item.id" :key="item.id" >{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="视频"></FormItem>
                        <div class="div1">
                            <div class="banner-box mb-0" @click="openModal(5)">
                                <Icon class="absolute-icon" type="md-add" size="44" color="#C0C4CC"/>
                                <video :src="newFormData.content.videoList.picview"></video>
                                <img class="del-icon-style" src="@/assets/homeset/del.png" @click.stop="delVideo(newFormData.content)"/>
                            </div>
                        </div>
                        <div class="form-title mt-24">播放设置</div>
                        <FormItem label="播放方式">
                            <RadioGroup v-model="newFormData.content.autoplay">
                                <Radio label="1">自动播放</Radio>
                                <Radio label="0">手动播放</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="循环播放">
                            <i-switch v-model="newFormData.content.loop" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeLoop">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <div class="form-title">组件间距</div>
                        <FormItem label="上下间距"><Slider class="w300" v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider class="w300" v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider class="w300" v-model=" newFormData.content.marginData.topRadius"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider class="w300" v-model=" newFormData.content.marginData.bottomRadius"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "video",
            switch_modal: false,
            name_id: "1",
            heightList: [
                { id: 1, name: "1：1" },
                { id: 2, name: "2：1" },
                { id: 3, name: "4：3" },
                { id: 4, name: "3：4" },
                { id: 5, name: "1：2" },
            ],
        };
    },
    mounted() {
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.videoList.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.videoList.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal() {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        // 删除视频
        delVideo(item) {
            item.videoList.picview = "https://qiniu-web-assets.dcloud.net.cn/unidoc/zh/2minute-demo.mp4";
        },
        changeLoop(e) {
            this.newFormData.content.loop = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.banner-box {
    margin: 12px 0;
    width: 100%;
    height: 130px;
    display: flex;
    justify-content: center;
    position: relative;
    border: 1px solid #c0c4cc;
}
.banner-box video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.del-icon-style {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 99;
    width: 26px !important;
    height: 26px !important;
    cursor: pointer;
}
.absolute-icon {
    position: absolute;
    font-size: 50px;
    cursor: pointer;
    color: #c0c4cc;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}
.div1 {
    padding: 12px;
    margin: 0 0 12px 0;
    border: 1px solid #c0c4cc;
}
</style>